import { AppLink } from '@/shared/components/AppLink';

interface PdpDesktopTagsProps {
  tags: unknown | null;
}

function parseTags(raw: unknown): Record<string, string> {
  if (!raw || typeof raw !== 'object') return {};
  return raw as Record<string, string>;
}

export function PdpDesktopTags({ tags }: PdpDesktopTagsProps) {
  const tagMap = parseTags(tags);
  const entries = Object.entries(tagMap);

  if (entries.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-2 px-4 py-3">
      {entries.map(([label, path]) => (
        <AppLink
          key={label}
          to={`/${path}`}
          shouldRefresh={false}
          className="text-xs capitalize text-[var(--link-blue)] hover:underline"
        >
          {label}
        </AppLink>
      ))}
    </div>
  );
}
